import type { DashboardScoreModule } from '@/core/domain/dashboard/DashboardScoreModule'
import type { IDashboardRepository } from '@/core/domain/dashboard/IDashboardRepository.ts'

export class FetchDashboardClassroomScoreModuleResultsUseCase {
  private readonly dashboardRepository: IDashboardRepository

  constructor(dashboardRepository: IDashboardRepository) {
    this.dashboardRepository = dashboardRepository
  }

  async execute(
    schoolId: number,
    schoolPeriodId: number,
    classroomId: number,
    taskId: number
  ): Promise<DashboardScoreModule[]> {
    return await this.dashboardRepository.fetchDashboardScoreModuleResults(
      schoolId,
      schoolPeriodId,
      classroomId,
      taskId
    )
  }
}
